import {
  GridItem,
  Switch,
  Box,
  Image,
  Text,
  Icon,
  useColorModeValue,
  VStack,
  Tooltip,
  IconButton,
  AspectRatio,
} from '@chakra-ui/react';
import { useGetImageUrl } from 'src/hooks';
import { Dish } from '../../utils/__generated__/graphql';
import { FaLeaf, FaDrumstickBite } from 'react-icons/fa';
import { FiEdit2 } from 'react-icons/fi';

interface FoodCardProps {
  dish: Dish;
  handleToggleStatus: (dish: Dish) => void;
  openEditModal: (dish: Dish) => void;
}

export const FoodCard: React.FC<FoodCardProps> = ({ dish, handleToggleStatus, openEditModal }) => {
  const { name, price, isActive, image, type, restaurant, description } = dish;
  const { imageUrl } = useGetImageUrl(image);

  // Color mode values
  const cardBg = useColorModeValue('white', 'gray.800');
  const textColor = useColorModeValue('gray.600', 'gray.300');
  const borderColor = useColorModeValue('gray.200', 'gray.700');
  const priceBg = useColorModeValue('brand.50', 'brand.900');
  const priceColor = useColorModeValue('brand.700', 'brand.200');

  const iconColor = type === 'NONVEG' ? 'red.500' : 'green.500';
  const iconComponent = type === 'NONVEG' ? FaDrumstickBite : FaLeaf;

  return (
    <GridItem>
      <Box
        bg={cardBg}
        borderWidth="1px"
        borderColor={borderColor}
        rounded="2xl"
        overflow="hidden"
        transition="all 0.3s"
        _hover={{
          transform: 'translateY(-2px)',
          shadow: 'lg',
          borderColor: 'brand.500',
        }}
      >
        {/* Image Container with AspectRatio */}
        <Box position="relative">
          <AspectRatio ratio={1}>
            <Image src={imageUrl || '/assets/img/food.jpg'} alt={name} objectFit="cover" w="100%" h="100%" />
          </AspectRatio>

          {/* Overlay gradient for better text visibility */}
          <Box
            position="absolute"
            top={0}
            left={0}
            right={0}
            bottom={0}
            bgGradient="linear(to-t, blackAlpha.600, transparent 50%)"
          />

          <IconButton
            position="absolute"
            top={3}
            right={3}
            p={4}
            icon={<Icon as={FiEdit2 as any} />}
            aria-label="Edit dish"
            onClick={() => openEditModal(dish)}
            variant="solid"
            colorScheme="blackAlpha"
            size="lg"
            rounded="full"
          />

          {/* Veg/Non-veg Icon */}
          <Tooltip label={type === 'NONVEG' ? 'Non-Vegetarian' : 'Vegetarian'}>
            <Box
              position="absolute"
              top={3}
              left={3}
              bg="white"
              rounded="full"
              alignContent={'center'}
              justifyContent={'center'}
              shadow="xs"
              p={2}
            >
              <Icon as={iconComponent as any} color={iconColor as any} />
            </Box>
          </Tooltip>

          {/* Price Tag */}
          <Box
            position="absolute"
            bottom={3}
            left={3}
            bg={priceBg}
            color={priceColor}
            px={3}
            py={1}
            rounded="full"
            fontSize="md"
            fontWeight="bold"
            shadow="md"
          >
            ₹{price}
          </Box>

          {/* Status Badge Tag */}

          <Switch
            position="absolute"
            bottom={3}
            right={3}
            colorScheme="brand"
            isChecked={Boolean(isActive)}
            id={`isAvailable-${dish.id}`}
            onChange={() => handleToggleStatus(dish)}
            size="lg"
            mr={2}
          />

          {/* <Box
            position="absolute"
            bottom={3}
            left={3}
            bg={priceBg}
            color={priceColor}
            px={3}
            py={1}
            rounded="full"
            fontSize="md"
            fontWeight="bold"
            shadow="md"
          >
            ₹{price}
          </Box> */}
        </Box>

        {/* Content Section */}
        <VStack p={4} align="stretch" spacing={2}>
          <Box>
            <Text fontSize="lg" fontWeight="bold" noOfLines={1} title={name}>
              {name}
            </Text>
            {restaurant?.name && (
              <Text fontSize="sm" color={textColor} noOfLines={1} mt={1}>
                {restaurant.name}
              </Text>
            )}
            {description && (
              <Text fontSize="sm" color={textColor} noOfLines={2} mt={2} title={description}>
                {description}
              </Text>
            )}
          </Box>

          {/* Controls Section */}
          {/* <Flex justify="space-between" align="center" pt={3} mt={2} borderTopWidth="1px" borderColor={borderColor}>
            <FormControl display="flex" alignItems="center" maxW="70%">
              <Switch
                colorScheme="brand"
                isChecked={Boolean(isActive)}
                id={`isAvailable-${dish.id}`}
                onChange={() => handleToggleStatus(dish)}
                size="lg"
                mr={2}
              />
              <FormLabel htmlFor={`isAvailable-${dish.id}`} mb="0" fontSize="sm" cursor="pointer">
                Available
              </FormLabel>
            </FormControl>
            <IconButton
              icon={<FiEdit2 />}
              aria-label="Edit dish"
              onClick={() => openEditModal(dish)}
              variant="ghost"
              colorScheme="brand"
              size="lg"
              rounded="full"
            />
          </Flex> */}
        </VStack>
      </Box>
    </GridItem>
  );
};
